// Container de toasts montado uma vez no shell. Segue o padrão mount/unmount.
import { html, render } from 'lit-html';
import { $toasts, dismissToast } from '../stores/toast.js';
import { icon } from './ui.js';

export function mountToastHost(container: HTMLElement): () => void {
  const template = () => html`
    <div class="toast-stack" aria-live="polite">
      ${$toasts.get().map(
        (t) => html`
          <div class="toast toast-${t.kind}" role="status">
            <span>${t.message}</span>
            <button class="toast-close" aria-label="Fechar" @click=${() => dismissToast(t.id)}>
              ${icon('x')}
            </button>
          </div>
        `,
      )}
    </div>
  `;
  const rerender = () => render(template(), container);
  const unsub = $toasts.subscribe(rerender);
  return () => {
    unsub();
    render(html``, container);
  };
}
